//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 28px 0 44px;
    padding: 0 clamp(20px, 3.8vw, 44px) 24px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    /* Restando a la altura mínima margin-top y margin-bottom */
    min-height: calc(var(--min-height-without-header) - 40px*2);
    width: 100%;

    @media (max-width: 900px) {
        padding-inline: clamp(18px, 4vw, 28px);
    }

    @media (max-width: 600px) {
        margin: 22px 0 36px;
        padding-inline: 16px;
    }
`;

export const HeroSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;
    max-width: 760px;
    width: min(100%, 760px);
    padding: 0 12px;
    box-sizing: border-box;
`;

export const Subtitle = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: var(--light-gray-5);
`;

export const CardLinkWrapper = styled.section`
    width: min(100%, 1120px);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(270px, 100%), 270px));
    justify-content: center;
    gap: 20px;
    align-items: stretch;
    margin: 0 auto;
    box-sizing: border-box;

    @media (max-width: 1180px) {
        width: min(100%, 980px);
        grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
    }

    @media (max-width: 900px) {
        grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
        gap: 18px;
    }

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
        width: min(100%, 560px);
        gap: 14px;
    }
`;
